module.exports = __webpack_public_path__ + "assets/img/lianxiwomen@2x.e1129226.png";